function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#1972E6"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.542 12.5)"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#1759BB",
  transform: "translate(0 1.374)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.9475413,22.2438988 L23.9475413,20.1611763 C23.9475413,19.442267 23.6885323,18.73393 23.2136824,18.1841758 C22.7712087,17.6661382 22.1992305,17.0635231 21.7351727,16.7146407 C19.6846847,15.1922446 16.684497,14.2196026 13.1554992,13.9341533 C11.8712462,13.8284314 11.4071884,13.8390036 10.0797673,13.9870143 C5.84928679,14.4627631 2.61167417,15.9005816 0.928115616,18.0467373 C0.863363363,18.1313148 0.798611111,18.2053202 0.744650901,18.2793256 C0.323761261,18.8185075 0.0971283784,19.4739836 0.0971283784,20.1506041 L0.0971283784,22.254471 C0.0971283784,24.041172 1.57563814,25.4895627 3.39949324,25.4895627 L20.6559685,25.4895627 C22.4690315,25.4684183 23.9475413,24.0200276 23.9475413,22.2438988 Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.914,
  cy: 5.445,
  rx: 5.504,
  ry: 5.392
})), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.9475413,22.2438988 L23.9475413,20.1611763 C23.9475413,19.442267 23.6885323,18.73393 23.2136824,18.1841758 C22.7712087,17.6661382 22.1992305,17.0635231 21.7351727,16.7146407 C19.6846847,15.1922446 16.684497,14.2196026 13.1554992,13.9341533 C11.8712462,13.8284314 11.4071884,13.8390036 10.0797673,13.9870143 C5.84928679,14.4627631 2.61167417,15.9005816 0.928115616,18.0467373 C0.863363363,18.1313148 0.798611111,18.2053202 0.744650901,18.2793256 C0.323761261,18.8185075 0.0971283784,19.4739836 0.0971283784,20.1506041 L0.0971283784,22.254471 C0.0971283784,24.041172 1.57563814,25.4895627 3.39949324,25.4895627 L20.6559685,25.4895627 C22.4690315,25.4789905 23.9475413,24.0305998 23.9475413,22.2438988 Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.914,
  cy: 5.445,
  rx: 5.504,
  ry: 5.392
}))));

var SvgGoogleContactsIco = function SvgGoogleContactsIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleContactsIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google_contacts_ico.cfcf6fde.svg";
export { ForwardRef as ReactComponent };